import { FormCheck, FormDone, FormFail, Pay3D } from './DefaultTemplate'
import { FormInitial } from './DefaultPassportTemplate'
import { FORM } from '@pay24/common/src/store/PaymentStore'
import { PaymentStore } from '@pay24/common/src/store'
import { Input } from '../Input'
import Spacer from '../Spacer'
import { observer } from 'mobx-react'
import React from 'react'
import * as yup from 'yup'

const FormBase = observer((props) => {
  const { service } = props
  const { payData } = PaymentStore

  const valid_fields = {
    contract_num: yup.string().required('Введите номер счёта'),
  }

  const renderFields = (errors) => {
    const fields = service.data && service.data.fields
    if (!fields || fields.length === 0 || Object.keys(fields).length === 0) {
      return null
    }

    const iban = fields.find((value) => value.name === 'contract_num')

    return (
      <>
        <Input
          testID="contract_num"
          errorText={errors?.contract_num}
          label={iban.label}
          value={payData.getOptions(iban.name)}
          onChangeText={(val) => {
            PaymentStore.payData.setOptions(iban.name, val)
          }}
        />
        <Spacer />
      </>
    )
  }

  return (
    <FormInitial
      {...props}
      customFields={renderFields}
      valid_fields={valid_fields}
    />
  )
})

export default (isAgent) => {
  if (isAgent) {
    return {
      steps: 4,
      [FORM.INITIAL]: FormBase,
      [FORM.CHECK]: FormCheck,
      [FORM.PAID]: FormDone,
      [FORM.FAIL]: FormFail,
    }
  }
  return {
    steps: 5,
    [FORM.INITIAL]: FormBase,
    [FORM.CHECK]: FormCheck,
    [FORM.PAYMENT_3D]: Pay3D,
    [FORM.PAID]: FormDone,
    [FORM.FAIL]: FormFail,
  }
}
